import { BoardMemberProps } from "@/types/board";
import { BoardMemberCard } from "./BoardMemberCard";

interface LeadershipSectionProps {
  leaders: BoardMemberProps[];
}

export const LeadershipSection = ({ leaders }: LeadershipSectionProps) => {
  console.log("LeadershipSection rendering with leaders:", leaders);
  
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16 max-w-5xl mx-auto">
      {leaders.map((leader, index) => {
        console.log(`Rendering leader ${index}:`, leader);
        return (
          <BoardMemberCard
            key={leader.name}
            {...leader}
            avatarSize="large"
            delay={index * 150}
          />
        );
      })}
    </div>
  );
};